export interface IContent {
  buttonText: string;
  title: string[];
  advsList: string[];
}

export const offlineContent: IContent = {
  buttonText: 'Назначить просмотр',
  title: ['Эта квартира сдаётся без залога и комиссий — с сервисом Сдай/Сними'],
  advsList: [
    'Квартира застрахована, поэтому залог не нужен',
    'Квартиру покажет агент, проверенный Циан',
    'Аренда оплачивается через сайт Циан без комиссии',
  ],
};

export const content: IContent = {
  buttonText: 'Заполнить анкету',
  title: ['Эта квартира сдаётся без залога и комиссий — с сервисом Сдай/Сними'],
  advsList: [
    'Квартира застрахована, поэтому залог не нужен',
    'Аренда оплачивается через сайт Циан без комиссии',
    'Вместо звонков владелец принимает анкеты',
  ],
};
